import React from 'react';
import Icon from './Icon';

const TrashIcon = (props) => (
    <Icon {...props}>
        <path
            d="M3.5 6H20.5M8.5 6L8.8 4.6C9 3.7 9.8 3 10.7 3H13.3C14.2 3 15 3.7 15.2 4.6L15.5 6M5.5 6L6.5 18.2C6.7 19.8 8 21 9.6 21H14.4C16 21 17.3 19.8 17.5 18.2L18.5 6M10 11L10.5 16M14 11L13.5 16"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default TrashIcon;
